export default {
  gamePlay: {
    playTitle: 'Code Input' as const,
    playInstructions:
      '<p>Transmission of safe combination complete.</p><p>Now crack the safe. Enter the passcode in the correct Color Order (top left).</p><p><strong>ADVANCED SAFE CRACKING:</strong></p><p>Some colors may appear more than once. Click those buttons in the order you saw them. But keep following the Color Order.</p>' as const,
    playButton: 'Start the heist!' as const,
  },
  rounds: {
    end: 'End of Round {{it.round}}' as const,
    playNext: 'Play next round!' as const,
    all: 'Excellent! You got {{it.correct}} trials correct!' as const,
    some: 'Great job! You got {{it.correct}} trials correct in this round.' as const,
    none: "Good try. Let's keep practicing!" as const,
  },
  gameComplete: {
    playTitle: 'Game Completed!' as const,
    playInstructions: 'Great work, keep practicing!' as const,
    playButton: 'Return to games' as const,
  },
  levelUp: {
    title: 'Amazing job, level up!!!' as const,
    bodyRender: (level: number) =>
      `Moving to level ${level}, and you got some tickets!`,
  },
  instructions: [
    {
      title: 'Safe Cracking 101' as const,
      body: ('Every safe has a different unlock code.<br>\n' +
        'You need the right buttons and the right Color Order.\n') as const,
      buttonText: 'Yes Sir!' as const,
      buttonAction: 'goToNext' as const,
      audio:
        '/assets/games/MasterThief/audio/instructions-safe-cracking-101-every.mp3',
    },
    {
      title: 'Color Code' as const,
      body: ("We'll show you the right buttons. Click them when they blink.<br>\n" +
        'REMEMBER their COLOR.') as const,
      buttonText: 'Yes Sir!' as const,
      buttonAction: 'goToNext' as const,
      audio:
        '/assets/games/MasterThief/audio/instructions-color-code-we-ll-show-y.mp3',
    },
    {
      title: 'Recover the Jewels' as const,
      body: ('Enter the unlock code in the correct Color Order.<br>' +
        'Some buttons may be the same color. Click them in the order that they appeared, but keep following the Color Order.') as const,
      buttonText: 'Yes Sir!' as const,
      buttonAction: 'goToNext' as const,
      audio:
        '/assets/games/MasterThief/audio/instructions-recover-the-jewels-ente.mp3',
    },
    {
      title: 'Ready to start?' as const,
      body: 'Press yes to start, no to see the instructions again.' as const,
      buttonText: 'yes' as const,
      buttonText2: 'no' as const,
      buttonAction: 'goToPlay' as const,
      buttonAction2: 'goToBeginning' as const,
      audio:
        '/assets/games/MasterThief/audio/instructions-ready-to-start-press-ye.mp3',
    },
  ] as const[],
};
